var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useInput, listen, useInputState } from '../components/input.hook';
import { cleanProps } from './autocomplete.helpers';
import { useList, useListFilter, useSelected, } from './hooks';
export function useAutocompleteInput(autocompletProps, ref) {
    var props = cleanProps(autocompletProps);
    var _a = useInputState(props, ref), value = _a.value, setValue = _a.setValue, inputProps = _a.inputProps, error = _a.error, initialState = _a.initialState;
    var state = __assign(__assign({}, initialState), { setDisplayIndex: function (index) { return list.select(index); }, clearFilter: function () {
            filter.clear();
            if (ref.current)
                ref.current.value = '';
        }, isEmpty: function () { return !filter.options.length; }, isInitialized: function () { return filter.initialized; }, getOptions: function () { return filter.options; }, getDisplayIndex: function () { return list.index; }, getSelectedIndex: function () { return selected.index; }, openPanel: function () { var _a; return (_a = input.panel) === null || _a === void 0 ? void 0 : _a.open(); }, closePanel: function () { var _a; return (_a = input.panel) === null || _a === void 0 ? void 0 : _a.close(); }, emitChange: function (value, event) {
            if (!value) {
                value = null;
                if (event.target)
                    event.target['value'] = null;
            }
            setValue(value);
            props.onChangeValue && props.onChangeValue(value);
            props.onChange && props.onChange(event);
        } });
    var filter = useListFilter(state, autocompletProps);
    var selected = useSelected(state, autocompletProps);
    var list = useList(state, autocompletProps);
    var input = useInput(state, props);
    React.useEffect(function () {
        if (value !== props.value) {
            setValue(props.value);
        }
    }, [props.value]);
    React.useEffect(function () {
        if (input.panel.show)
            input.chevron.set('down');
        else
            input.chevron.set('up');
    }, [input.panel.show]);
    return {
        isLoading: state.isLoading(),
        isEmpty: state.isEmpty(),
        isInitialized: state.isInitialized(),
        options: state.getOptions(),
        selected: value,
        selectedIndex: selected.index,
        displayIndex: list.index,
        onSelect: selected.select,
        format: filter.format,
        container: __assign(__assign({}, input.container), { onRootClick: listen(input.container.onRootClick, function () { return input.panel.open(); }), error: props.error || error }),
        input: __assign(__assign(__assign({}, inputProps), input.input), { value: undefined, readOnly: props.select || inputProps.readOnly || input.input.readOnly, onChange: listen(filter.onChange), onKeyDown: listen(list.onKeyDown, input.input.onKeyDown), onKeyUp: listen(selected.onKeyUp, input.input.onKeyUp) })
    };
}
